import rawIcons from './data/icons.json' with { type: 'json' };
/**
 * List of all icons available in the library.
 */
// @ts-ignore
export const icons = rawIcons;
let iconNamesSet = null;
/**
 * Validate that the icon name is valid.
 */
export function validateIconName(icon) {
    if (!iconNamesSet) {
        iconNamesSet = new Set(icons.map((icon) => icon.icon));
    }
    return iconNamesSet.has(icon);
}
